<template>
  <v-main class="fill-height">
    <service-worker-notify />
    <router-view />

    <dashboard-core-footer />
  </v-main>
</template>

<script>
  export default {
    name: 'DashboardCoreView',

    components: {
      DashboardCoreFooter: () => import('./Footer'),
      ServiceWorkerNotify: () => import('@/components/pow/swUpdateBar'),
    },
  }
</script>
